module.exports = __webpack_public_path__ + "static/assets/ee54d776d2cda9a3c537ac7e8f144037.svg";